import './scss/index.scss';
import { dcFactory } from '@deleteagency/dc';
import {QuickSearch_PopularSearches} from './js/quick-search.component';
import {FilterSearch_PopularSearches} from './js/filter-search.component';

dcFactory.register(QuickSearch_PopularSearches);
dcFactory.register(FilterSearch_PopularSearches);
